import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  Validator,
  ValidatorFn,
} from '@angular/forms';

/**
 *  This directive creates a custom form validation which validates when a soft limit has been reached on an input field.
 *  It will create a warning error after a certain number of characters have been entered. ie. If you want to let users
 *  know their optimal text length has been reached after a certain number of characters have been typed.
 */

export function checkSoftLimit(softCharacterLimit: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let isSoftLimit = false;
    if (control.value.length > softCharacterLimit) {
      isSoftLimit = true;
    }
    return isSoftLimit
      ? {
          softLimit: {
            value: control.value,
          },
        }
      : null;
  };
}

@Directive({
  selector: '[dgxSoftLimitValidation]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: SoftLimitValidatorDirective,
      multi: true, // adds soft limit validator to existing validators
    },
  ],
})
export class SoftLimitValidatorDirective implements Validator {
  @Input('dgxSoftLimitValidation') public softCharacterLimit = 180; // default soft character limit to 180 characters
  public validate(control: AbstractControl): { [key: string]: any } | null {
    const inputText = control.value;
    return this.softCharacterLimit && inputText
      ? checkSoftLimit(this.softCharacterLimit)(control)
      : null;
  }
}
